"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuery = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var useQuery = exports.useQuery = function useQuery() {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  return (0, _react.useMemo)(function () {
    return new URLSearchParams(search);
  }, [search]);
};